import React, { useState } from "react";
import "./home.css";
import { CgChevronDown } from "react-icons/cg";
import bgOne from "../Assets/fond-1.jpg";
import bgTwo from "../Assets/fond-2.jpg";
import { FormattedMessage } from "react-intl";

const Home = () => {
  const [imageActive, setImageActive] = useState(true);

  return (
    <section id="home" className="home-wrapper">
      <div className="container home-container">
        <div className="text-content">
          <h1 className="big-title wow bounceInLeft">
            <FormattedMessage id="home.hello" defaultMessage="Hello! I'm Ny," />
            <br />
            <FormattedMessage id="home.webdeveloper" defaultMessage="web developer." />
          </h1>
          <h3 className="text-yellow-with-line">
            <FormattedMessage id="home.aboutme" defaultMessage="About me" />
          </h3>
          <p className="wow fadeInLeft">
            <FormattedMessage id="home.description" />
          </p>
        </div>
        <div className="bloc-fond" style={{ backgroundImage: `url(${imageActive ? bgOne : bgTwo})` }}></div>
        <div className="card-wrapper">
          <div className={`bg-dark ${!imageActive && "active"}`}></div>
          <div onMouseOver={() => setImageActive(true)} className={` ${imageActive ? "active" : ""} card-item`}>
            <h3 className="wow fadeIn"><FormattedMessage id="home.webintegration" defaultMessage="WEB INTEGRATION" /></h3>
            <p className="wow fadeIn"><FormattedMessage id="home.witext" /></p>
          </div>
          <div onMouseOver={() => setImageActive(false)} className={` ${!imageActive ? "active" : ""} card-item`}>
            <h3 className="wow fadeIn"><FormattedMessage id="home.webproject" defaultMessage="WEB PROJECT" /></h3>
            <p className="wow fadeIn"><FormattedMessage id="home.wptext" /></p>
          </div>
        </div>
        <a className="btn-arrow-down" href="#skills">
          <CgChevronDown size="1.5em" />
        </a>
      </div>
    </section>
  );
};

export default Home;
